<app-spinner-overlay></app-spinner-overlay>
<app-titolo-subtitolo
  [titolo]="'Criteri per l’assegnazione degli IRO'"
  [subTitolo]="
    'Descrivere i criteri seguiti per l’individuazione degli IRO da sottoporre a valutazione della categoria di stakeholder.'
  "
></app-titolo-subtitolo>

<div mat-dialog-content class="dialog-center-cont">
  <div appFormContainer [larghezza]="3">
    <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
      <textarea
        matInput
        placeholder="Inserisci testo"
        [(ngModel)]="testoCriterio"
        rows="4"
        [disabled]="data.isDisabled ?? false"
        [required]="obbligatorio"
      ></textarea>
      <mat-error appFormError></mat-error>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-flat-button color="accent" class="accent-button" (click)="chiudi()">Chiudi</button>
  </div>
  <div *ngIf="!data.isDisabled">
    <button mat-flat-button color="primary" (click)="conferma()" class="primary-button">
      Conferma
    </button>
  </div>
</div>
